import React, { useState, useMemo } from "react";
import { Building2 } from "lucide-react";

import { DashboardCard } from "../DashboardCard";
import { CardHeader } from "../CardHeader";
import { DashboardDropdown } from "../DashboardDropdown";
import { DepartmentBarChart } from "../charts/DepartmentBarChart";

import { getDepartmentDistribution } from "../../services/dashboardAnalytics";

const DEPT_VIEW_OPTIONS = [
  { value: "EMPLOYEE", label: "By Employee" },
  { value: "PERCENT", label: "By Share %" },
];

export const DepartmentDistributionCard = React.memo(
  function DepartmentDistributionCard({
    employees,
    activeDept,
    onDeptClick,
  }) {
    const [view, setView] = useState("EMPLOYEE");

    const departmentData = useMemo(
      () => getDepartmentDistribution(employees),
      [employees]
    );

    const totalEmployees = employees.length;

    const displayData = useMemo(() => {
      if (view === "EMPLOYEE") return departmentData;

      return departmentData.map((department) => ({
        ...department,
        count: totalEmployees
          ? Number(((department.count / totalEmployees) * 100).toFixed(1))
          : 0,
      }));
    }, [departmentData, view, totalEmployees]);

    return (
      <DashboardCard>
        <CardHeader
          icon={Building2}
          iconBg="#EFF6FF"
          iconColor="#2563EB"
          title="Department Distribution"
          action={
            <DashboardDropdown
              value={view}
              options={DEPT_VIEW_OPTIONS}
              onChange={setView}
            />
          }
        />

        <div className="text-xs text-slate-400 font-medium mb-3">
          Employees by Department
        </div>

        <div className="flex-1">
          <DepartmentBarChart
            data={displayData}
            activeDept={activeDept}
            onBarClick={onDeptClick}
          />
        </div>
      </DashboardCard>
    );
  }
);